import { useRef } from "react";
import { TRABrandLockup } from "../brand";
import { useProfilePlatformFonts } from "../../features/profile/hooks/useProfilePlatformFonts";
import { usePlayerProfileTheme } from "../../features/profile/hooks/usePlayerProfileTheme";
import "../../features/profile/styles/profileClaude.module.css";
import s from "./appLoadingShell.module.css";

/**
 * Profile-aligned full-screen loader (mobile 480px column).
 * @param {{ variant?: "splash" | "route"; message?: string; "aria-label"?: string }} props
 */
export default function AppLoadingShell({
  variant = "splash",
  message,
  "aria-label": ariaLabel = "Loading",
}) {
  const shellRef = useRef(null);
  useProfilePlatformFonts();
  usePlayerProfileTheme(shellRef, true);

  const showBrand = variant === "splash";

  return (
    <div
      ref={shellRef}
      className={`tra-player-profile tra-visual-v2 ss-player-route ${s.shell}`}
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <div className={s.frame}>
        {showBrand ? (
          <header className={s.topBar}>
            <TRABrandLockup size="md" />
          </header>
        ) : null}
        <div className={variant === "splash" ? s.splashBody : undefined}>
          {variant === "route" ? (
            <>
              <div className={s.skelBlock} />
              <div className={s.skelBlockTall} />
              <div className={s.skelBlockShort} />
            </>
          ) : (
            message ? <p className={s.message}>{message}</p> : null
          )}
        </div>
      </div>
    </div>
  );
}
